// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

type AppType = 'admin' | 'advisor' | 'client' | 'marketing';

export function extractTenant(appType: AppType): string {
  if (appType === 'admin') return 'platform';
  if (appType === 'marketing') return 'marketing';

  try {
    const hostname = window.location.hostname;
    // Pattern: {tenant}.advisor.localhost.com or {tenant}.client.localhost.com
    const parts = hostname.split('.');
    if (parts.length >= 3) {
      return parts[0];
    }
  } catch {
    // SSR or window unavailable
  }

  return 'unknown';
}
